import { motion } from "framer-motion";

const SECTIONS = [
    {
        title: "1. The Service",
        body: "Dichotomy Sisters LLC (\u201cwe\u201d, \u201cus\u201d), with registered office at 1209 North Orange Street, Wilmington, DE 19801, USA. We provide spiritual entertainment services: live chat readings, recognition readings, custom rituals, and physical ritual objects. All readings, recognitions, oracles and ritual work are offered for spiritual guidance and entertainment purposes only.",
    },
    {
        title: "2. Eligibility",
        body: "You must be at least 18 years old and able to form a binding contract under the laws of the United States to use this service. By entering the Back Room you confirm that you meet this requirement.",
    },
    {
        title: "3. Readings & Live Chat Billing",
        body: "Live chat with Mara is billed per active minute at the rate displayed before purchase. Prepaid mirror-time is purchased in advance, is deducted only while a session is running, and never expires. Once session time has been consumed it is non-refundable; unused prepaid minutes may be refunded within 14 days of purchase upon request through the Back Room.",
    },
    {
        title: "4. The Free Hours Promotion",
        body: "During the promotional window, each visitor may claim one free reading of up to five (5) minutes. One claim per person. The promotion ends when the on-site countdown reaches zero; we may extend, pause or withdraw it at any time without notice.",
    },
    {
        title: "5. Ritual Objects",
        body: "Physical items from the Ritual Collection are prepared to order and shipped from the United States to the countries offered at checkout. Delivery times vary by destination. Unopened items may be returned within 14 days of delivery for a refund of the purchase price, excluding shipping. Ritual objects are spiritual curios; no supernatural outcome is warranted.",
    },
    {
        title: "6. No Professional Advice",
        body: "Nothing on this site constitutes medical, psychological, legal, financial or other licensed professional advice. If you are facing a health, mental-health, legal or financial matter, consult a licensed professional in your jurisdiction.",
    },
    {
        title: "7. Privacy, In Brief",
        body: "We collect only what a reading requires: your name, email, and what you choose to tell Mara. Conversations and uploads are private to you and Mara, are never sold, and are never shared with third parties except as required by law or to process payment and delivery.",
    },
    {
        title: "8. Governing Law",
        body: "These Terms are governed by the laws of the State of Delaware, United States of America, without regard to conflict-of-law principles. Any dispute shall be brought exclusively in the state or federal courts located in Wilmington, Delaware.",
    },
    {
        title: "9. Contact",
        body: "Questions about these Terms may be brought to Mara directly inside the Back Room, or by reply to any whisper email you receive from us.",
    },
];

export const TermsPage = () => {
    return (
        <div data-testid="terms-page" className="relative mx-auto min-h-screen max-w-3xl px-5 py-24 sm:px-8">
            <div className="nebula-blob right-[-10%] top-[5%] h-96 w-96 bg-[#5a189a]/20" />
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
                <a href="/" data-testid="terms-home-link" className="flex items-center gap-3">
                    <img src="/assets/sisters-mark.png" alt="" className="h-10 w-10 rounded-full ring-1 ring-[#c77dff]/40" />
                    <span className="font-cinzel text-sm font-semibold tracking-[0.3em] text-[#f8f7ff]">
                        DICHOTOMY <span className="text-[#c77dff]">SISTERS</span>
                    </span>
                </a>

                <p className="eyebrow mb-4 mt-14">The Fine Print · United States of America</p>
                <h1 className="text-glow-lilac font-display text-3xl font-bold tracking-wide text-[#f8f7ff] sm:text-4xl">
                    TERMS &amp; CONDITIONS
                </h1>
                <p className="mt-4 font-cormorant text-base italic text-[#e0aaff]/70">
                    Effective September 5, 2026 · Dichotomy Sisters, operating from the United States of America
                </p>

                <div className="mt-12 space-y-10">
                    {SECTIONS.map((s) => (
                        <section key={s.title} data-testid={`terms-${s.title.split(".")[0].replace(/\s/g, "-")}`}>
                            <h2 className="font-cinzel text-base font-semibold tracking-[0.15em] text-[#e0aaff]">
                                {s.title}
                            </h2>
                            <p className="mt-3 text-sm leading-relaxed text-[#f8f7ff]/75">{s.body}</p>
                        </section>
                    ))}
                </div>

                <p className="mt-16 border-t border-purple-500/15 pt-8 text-center font-cormorant text-sm italic text-[#c77dff]/60">
                    Crafted with intention in the United States of America. Not every mirror holds a soul.
                </p>
            </motion.div>
        </div>
    );
};
